import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { useNavigate, useParams } from "react-router-dom";
import { useModal } from "../../../hooks";

import { Input } from "../../../components/core/Input"
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import StyledWrapper from "./style"
import LavorisService from "../../../services/LavorisService";
import AcceptedPass from "./acceptedPass"
import { useAlert } from "../../../hooks/useAlert";
import CryptoJS from 'crypto-js';

type FormValue = {
    password: string,
    repeatPass: string
}

type body = {
    validationBody: {
        type: string,
        password: string
    }
}

const ACCEPTED_PASS = "acceptedPass"

export const AddPassword = () => {
    const [samePassword, setSamePassword] = useState<boolean>(false);
    const [logError, setLogError] = useState<boolean>(false);
    const [passCaracteres, setPassCaracteres] = useState<boolean>(true);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { openModal, closeModal, isActive } = useModal()
    const { showAlert } = useAlert();
    const { id, type } = useParams();
    const LavorisInstance = LavorisService.getInstance()
    const navigate = useNavigate()
    const { register, handleSubmit, formState: { errors }, watch } = useForm<FormValue>({ mode: "all" });
    const [errorMessage, setErrorMessage] = useState<null>()

    const pass = watch("password") || ""
    const repeatPass = watch("repeatPass") || ""
    // Nueva regex para validar la seguridad de la contraseña
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~])[A-Za-z\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]{12,}$/;

    const encryptPassword = (password: string) => {
        const secretKey = process.env.REACT_APP_CRYPTO_SECRET || ""; // Usa una clave segura y almacénala de forma segura
        return CryptoJS.AES.encrypt(password, secretKey).toString();
    };


    useEffect(() => {
        setSamePassword(pass === repeatPass)
        setPassCaracteres(passwordRegex.test(pass))
    }, [pass, repeatPass])

    const addPassword = async (data: body) => {
        setIsLoading(true)
        setLogError(false)
        if (!passCaracteres) {
            setIsLoading(false);
            showAlert('La contraseña debe tener al menos 12 caracteres, una mayúscula, una minúscula, un número y un símbolo especial (No se admiten acentos ni caracteres acentuados).');
            return;
        }

        await LavorisInstance.ValidationService.addPassword(id, data)
            .then((res) => {
                console.log(res)
                openModal(ACCEPTED_PASS)
            }).catch((err) => {
                console.log(err.response.data.message)
                setErrorMessage(err.response.data.message)
                setLogError(true)
            })
            .finally(() => setIsLoading(false))
    }

    const onAccept = () => {
        closeModal(ACCEPTED_PASS)
        if (type && type == 'lnpass') {
            window.location.href = `${process.env.REACT_APP_LN_SITE_URL}/login`
        }
        else
            navigate("/")
    }

    const onSubmit = (data: FormValue) => {
        addPassword(
            {
                validationBody: {
                    type: "CREATE_PASSWORD",
                    password: encryptPassword(data.password?.trim()),
                }
            }
        )
    }

    return (
        <>
            <div className="min-h-[73vh] w-full flex justify-center">
                <StyledWrapper.Card>
                    <StyledWrapper.Form>
                        <form onSubmit={handleSubmit(onSubmit)} className="grid grid-rows-6 gap-2">
                            <h2 className="font-bold w-full flex justify-center text-xl">Generación de Contraseña de Acceso</h2>
                            <p className="text-start">Defina una contraseña para ingresar al sistema</p>
                            <Input
                                register={register}
                                type="password"
                                label="Contraseña"
                                fieldName="password"
                                error={errors.password}
                                onPaste={(e) => e.preventDefault()}
                                required
                            />
                            <p
                                className={`flex w-full start ${passCaracteres
                                    ? "text-green-500 text-[13px]"
                                    : "text-red-500 text-[13px]"
                                    }`}
                            >
                                {passCaracteres
                                    ? "La contraseña cumple con los requisitos de seguridad."
                                    : "Debe tener al menos 12 caracteres, una mayúscula, una minúscula, un número y un símbolo especial (No se admiten acentos ni caracteres acentuados)."}
                            </p>

                            <Input
                                register={register}
                                type="password"
                                label="Repetir Contraseña"
                                fieldName="repeatPass"
                                error={errors.password}
                                onPaste={(e) => e.preventDefault()}
                                required
                            />
                            {!samePassword && (
                                <p className="flex w-full justify-start text-red-500">
                                    *Las contraseñas no son iguales
                                </p>
                            )}

                            {
                                passCaracteres && (
                                    <div className="w-full flex justify-center">
                                        <PrimaryButton
                                            type="submit"
                                            text="Confirmar"
                                            styles="bg-red-500 w-1/3 font-bold text-white"
                                            disabled={isLoading}
                                        />
                                    </div>
                                )
                            }


                            {logError && (
                                <p className="flex w-full mt-2 justify-center text-center text-red-500">
                                    {errorMessage || 'No se pudo crear/actualizar la constraseña, intente más tarde y si sigue asi consulte con Lavoris.'}
                                </p>
                            )}
                        </form>
                    </StyledWrapper.Form>

                </StyledWrapper.Card>
            </div>
            <div className='w-auto m-[auto] flex justify-center'>
                {
                    isActive(ACCEPTED_PASS) &&
                    <AcceptedPass
                        toggleModal={true}
                        urlTittle={ACCEPTED_PASS}
                        handleClick={onAccept}
                    />
                }
            </div>
        </>


    )
}